<div class="live-indicator">
  <span class="live-indicator__box">
    <span class="live-indicator__dot {{ liveModeClass }}"></span>
  </span>
  @if (text) {
    <span class="live-indicator__text">{{ text }}</span>
  }
</div>
